"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var SvgEyeOff = function SvgEyeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M16.774 17.835l-2.692-2.692a3.75 3.75 0 01-5.225-5.225L6.002 7.063a17.7 17.7 0 00-4.147 4.94 18.76 18.76 0 002.568 3.484c2.214 2.362 4.752 3.763 7.565 3.763a9.32 9.32 0 004.786-1.415zm1.688-.434a.75.75 0 01.016.016l5.052 5.053a.75.75 0 01-1.06 1.06l-4.611-4.61A10.833 10.833 0 0112 20.75c-3.3 0-6.2-1.6-8.672-4.237a20.245 20.245 0 01-2.796-3.802 9.492 9.492 0 01-.203-.376.75.75 0 01.01-.69 19.2 19.2 0 014.598-5.647L.47 1.53A.75.75 0 011.53.47l5.052 5.05a.75.75 0 01.016.017l3.81 3.81.005.005 4.235 4.235.005.006 3.809 3.808zm-8.517-6.395a2.25 2.25 0 003.05 3.049l-3.05-3.05zm10.321 3.701a17.75 17.75 0 001.88-2.71 18.76 18.76 0 00-2.568-3.484c-2.215-2.362-4.753-3.763-7.58-3.763a8.37 8.37 0 00-1.927.22.75.75 0 01-.342-1.46A9.868 9.868 0 0112 3.25c3.3 0 6.2 1.6 8.672 4.237a20.245 20.245 0 012.796 3.802c.099.175.166.302.203.376a.75.75 0 01-.01.689 19.25 19.25 0 01-2.247 3.319.75.75 0 11-1.148-.966z"
  }));
};
SvgEyeOff.propTypes = process.env.NODE_ENV !== "production" ? {
  color: _propTypes["default"].string,
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
SvgEyeOff.defaultProps = {
  color: "currentColor",
  size: "24"
};
var _default = SvgEyeOff;
exports["default"] = _default;
module.exports = exports.default;